// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"aY-z","subtitle":"bY-z","wrapper":"cY-z","leftArrow":"dY-z","rightArrow":"eY-z"};